import { putApiGalaxyServer } from 'services';

/**
 * Tiers the "Chello Subscription Tier" bulk action offers (GLX-1945).
 * ai-server also knows Max and Internal; galaxy-server rejects both.
 */
export const CHELLO_TIERS = ['Base', 'Pro'] as const;
export type ChelloTier = (typeof CHELLO_TIERS)[number];

export interface SetChelloTierPayload {
  teamId: number;
  /** Mosaic account ids of the members to put on `tier`. */
  memberIds: number[];
  tier: ChelloTier;
}

export interface SetChelloTierResponse {
  teamId: number;
  tier: ChelloTier;
  /** Members whose current-month subscription was switched to `tier`. */
  updated: number;
  /** Members with no current-month subscription, given a new one on `tier`. */
  created: number;
  /** Members already on `tier` this month. */
  unchanged: number;
}

/**
 * Set the Chello subscription tier of a team's members for the billing month in
 * progress, through galaxy-server's ai-server bridge.
 */
export const setChelloTierApi = ({
  params: { teamId, memberIds, tier },
  token,
  config,
}: BaseApiParams<SetChelloTierPayload>) =>
  putApiGalaxyServer<Omit<SetChelloTierPayload, 'teamId'>, SetChelloTierResponse>(
    `/ai_api/teams/${teamId}/chello-tier`,
    { memberIds, tier },
    config ?? {},
    token,
  );
